import qs from 'qs'

import api from '@/client/core/api'
import { GetTwitterBenchmarkCampaignPostsCsvQuery, PostCsvResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts/csv
 */
export async function getTwBenchmarkPostsCsv(
  query: GetTwitterBenchmarkCampaignPostsCsvQuery
): Promise<TwBenchmarkApiResult<PostCsvResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<PostCsvResponse>>('/twitter_benchmark_campaign_posts/csv', {
    params: query,
    paramsSerializer: (params: Record<string, unknown>) => qs.stringify(params, { arrayFormat: 'brackets' })
  })

  return handleApiResponse<PostCsvResponse>(response)
}
